<template>
  <div>
    <b-card>
      <AgGrid
        ref="BookingGrid"
        :grid="aggrid"
        @LoadAll="LoadAll"
      >
        <template v-slot:lftbtn>
          <b-button
            v-if="((Role != 'readonly' && Role != 'readonly admin') && (Permission.CreateBooking)) || (Role == 'company admin')"
            v-b-tooltip.hover="'Create a New entry'"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-1"
            @click="CreateNewBooking()"
          ><font-awesome-icon
             :icon="['far', 'plus-square']"
             class="mr-50"
             size="lg"
           />
            <span class="align-middle">New Booking</span></b-button>
        </template>

      </AgGrid>
    </b-card>

    <b-modal
      id="CreateBookingModal"
      ref="CreateBooking"
      title="New Booking"
      size="lg"
      centered
      no-close-on-backdrop
    >
      <validation-observer
        ref="headerRules"
        tag="form"
      >
        <b-row>
          <b-col md="4">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Customer"
                rules="required"
              >
                <b-form-group
                  :state="errors.length > 0 ? false:null"
                >
                  <label class="required"><i><b>Customer:</b></i></label>
                  <v-select
                    id="CustomerOption"
                    v-model="BKDetail.CustomerId"
                    :options="CustomerOptions"
                    label="name"
                    placeholder="Select a Customer"
                    @input="onChangeSetBookingNumber"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="HBL/Booking #"
                rules="max:50|required"
              >
                <b-form-group
                  :state="errors.length > 0 ? false:null"
                >
                  <label class="required"><i><b>HBL/Booking #:</b></i></label>
                  <b-form-input
                    id="BookingNumber"
                    v-model="BKDetail.BookingNumber"
                    :state="errors.length > 0 ? false:null"
                    :disabled="CheckNull(BKDetail.CustomerId) ? false : true"
                    placeholder="HBL/Booking #"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Booking Mode"
                rules="required"
              >
                <b-form-group
                  :state="errors.length > 0 ? false:null"
                >
                  <label class="required"><i><b>Booking Mode:</b></i></label>
                  <v-select
                    id="BookingModeOption"
                    v-model="BKDetail.BookingMode"
                    :options="BookingModeOptions"
                    :disabled="CheckNull(BKDetail.CustomerId) ? false : true"
                    label="text"
                    placeholder="Select a mode"
                  />
                  <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
      <template #modal-footer>
        <div>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-1"
            @click="SaveNewBooking()"
          >
            <span class="align-middle">Save</span></b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from '@axios'

import { required } from '@validations'
import ViewBtnRenderer from '@core/layouts/ViewBtnRenderers/Booking/BookingViewBtnRenderer'
import AgGrid from '@/layouts/components/AgGrid.vue'

export default {
  components: {
    AgGrid,
  },
  data() {
    return {
      required,
      BookingId: '',
      aggrid: [],
      CustomerOptions: [],
      BookingModeOptions: [
        { text: 'Air', value: 'Air' },
        { text: 'LCL', value: 'LCL' },
        { text: 'FCL', value: 'FCL' },
        { text: 'BCN', value: 'BCN' },
      ],
      BKDetail: {
        CustomerId: '',
        BookingNumber: '',
        BookingMode: '',
      },
      Permission: {},
      Role: '',
    }
  },
  beforeMount() {
    axios.defaults.headers.common.DBContext = this.$store.state.user.AppActiveUser.BookingDbContext
    this.aggrid = this.InitGridInstance('Booking')
    this.aggrid.columnDefs = [
      {
        headerName: '',
        field: 'bookingId',
        filter: false,
        sortable: false,
        autoHeight: true,
        width: 60,
        minWidth: 60,
        maxWidth: 60,
        suppressSizeToFit: true,
        suppressMovable: true,
        pinned: 'left',
        lockPinned: true,
        cellRenderer: 'ViewBtnRenderer',
        enableRowGroup: false,
        enablePivot: false,
      },
      {
        headerName: 'Status',
        field: 'status',
        minWidth: 135,
        filter: 'agSetColumnFilter',
        // eslint-disable-next-line no-nested-ternary
        cellRenderer: params => (params.value === 'Approved' || params.value === 'Approved/Confirmed' ? `<span style="color:green">${params.value}</span>` : params.value === 'Pending Review' || params.value === 'Approved/Pending' ? `<span style="color:coral">${params.value}</span>` : params.value === 'Denied' ? `<span style="color:red">${params.value}</span>` : params.value === 'Attached' ? `<span style="color:purple">${params.value}</span>` : params.value === 'Cancelled' ? `<span style="color:red">${params.value}</span>` : `${params.value}`),
      },
      {
        headerName: 'Customer', field: 'customerName', minWidth: 125, filter: 'agSetColumnFilter',
      },
      {
        headerName: 'HBL/Booking #', field: 'bookingNumber', minWidth: 155, enableRowGroup: false, enablePivot: false,
      },
      {
        headerName: 'Customer Reference', field: 'customerReference', minWidth: 155, enableRowGroup: false, enablePivot: false,
      },
      {
        headerName: 'Mode', field: 'bookingMode', minWidth: 75, filter: 'agSetColumnFilter',
      },
      {
        headerName: 'Service Type', field: 'bookingType', minWidth: 75, filter: 'agSetColumnFilter',
      },
      {
        headerName: 'Service Mode', field: 'serviceType', minWidth: 85, filter: 'agSetColumnFilter',
      },
      {
        headerName: 'Consingee', field: 'consigneeName', minWidth: 85, filter: 'agSetColumnFilter',
      },
      {
        headerName: 'Shipper', field: 'sellerName', minWidth: 85, filter: 'agSetColumnFilter',
      },
      {
        headerName: 'PO Number',
        field: 'poNumber',
        maxWidth: 195,
        enableRowGroup: false,
        enablePivot: false,
        autoHeight: true,
        wrapText: true,
      },
      {
        headerName: 'Booking Date',
        field: 'receivedDate',
        maxWidth: 150,
        filter: 'agDateColumnFilter',
        comparator: this.dateComparator,
        filterParams: this.$filterParams,
      },
      {
        headerName: 'Approval Date',
        field: 'approvedDate',
        maxWidth: 150,
        filter: 'agDateColumnFilter',
        comparator: this.dateComparator,
        filterParams: this.$filterParams,
      },
      {
        headerName: 'Cargo Ready',
        field: 'cargoReadyDate',
        maxWidth: 150,
        filter: 'agDateColumnFilter',
        comparator: this.dateComparator,
        filterParams: this.$filterParams,
      },
      {
        headerName: '# Containers', field: 'totalContainers', minWidth: 100,
      },
      {
        headerName: 'Delivery Location', field: 'deliveryLocation', minWidth: 80,
      },
      {
        headerName: 'Final Destination', field: 'finalDest', minWidth: 80,
      },
      {
        headerName: 'CBM / Weight / Pallet',
        field: 'cbm',
        minWidth: 100,
        enableRowGroup: false,
        enablePivot: false,
        cellRenderer: 'agGroupCellRenderer',
        cellRendererParams: {
          innerRenderer: params => `${params.value || '0'} / ${params.data.weight || '0'} / ${params.data.pallet || '0'}`,
        },
      },
      {
        headerName: 'Edit Log',
        marryChildren: true,
        children: [
          {
            headerName: 'Updated By', field: 'updatedBy', maxWidth: 134, minWidth: 100,
          },
          {
            headerName: 'Updated On',
            field: 'updatedOn',
            maxWidth: 158,
            minWidth: 100,
            comparator: this.dateComparator,
            filterParams: this.$filterParams,
            enableRowGroup: false,
            enablePivot: false,
          },
          {
            headerName: 'Added By', columnGroupShow: 'open', field: 'createdBy', maxWidth: 134, minWidth: 100,
          },
          {
            headerName: 'Added On',
            columnGroupShow: 'open',
            field: 'createdOn',
            maxWidth: 158,
            minWidth: 100,
            comparator: this.dateComparator,
            filterParams: this.$filterParams,
            enableRowGroup: false,
            enablePivot: false,
          },
        ],
      },
    ]

    this.aggrid.gridOptions.onSortChanged = () => { this.$refs.BookingGrid.saveState('Booking') }
    this.aggrid.gridOptions.onColumnResized = () => { this.$refs.BookingGrid.saveState('Booking') }
    this.aggrid.gridOptions.onColumnMoved = () => { this.$refs.BookingGrid.saveState('Booking') }
    this.aggrid.gridOptions.onFilterChanged = () => { this.$refs.BookingGrid.saveState('Booking') }

    this.aggrid.frameworkComponents = {
      ViewBtnRenderer,
    }
    this.LoadAll()
  },
  methods: {
    Open(BookingId) {
      this.BookingId = BookingId
      this.$router.push(`/booking/detail/${BookingId}`)
    },
    DoubleClickOpenPopup(params) {
      this.BookingId = params.data.bookingId
      this.$router.push(`/booking/detail/${params.data.bookingId}`)
    },
    LoadAll() {
      Promise.all([this.LoadingStart(), this.LoadBookingList(), this.LoadCustomerList()])
        .then(() => {
          // Get user role
          this.Role = this.GetUserRole()
          // Get permission
          this.Permission = this.GetUserPermission('Booking')
          this.LoadingEnd()
        })
    },
    LoadCustomerList() {
      // Loading Customer List
      return axios.get('/booking/customer/codes/all')
        .then(rowData => {
          this.CustomerOptions = rowData.data
        })
    },
    LoadBookingList() {
      axios.get('/booking/active')
        .then(rowData => {
          this.aggrid.rowData = rowData.data
        }).then(() => {
          this.$refs.BookingGrid.ResetColumns()
        })
    },
    CreateNewBooking() {
      this.$refs.CreateBooking.show()
    },
    SaveNewBooking() {
      this.$refs.headerRules.validate().then(result => {
        if (result) {
          this.LoadingStart()
          const BookingModel = {
            CustomerId: this.BKDetail.CustomerId.id,
            BookingNumber: this.BKDetail.BookingNumber,
            BookingMode: this.BKDetail.BookingMode.value,
          }

          axios.post('/booking', BookingModel)
            .then(response => {
              this.LoadingEnd()
              this.$refs.CreateBooking.hide()
              this.DisplaySuccess('Booking data has been saved.').then(() => {
                this.$router.push(`/booking/detail/${response.data}`)
              })
            })
            .catch(e => {
              this.LoadingEnd()
              this.$refs.CreateBooking.hide()
              this.DisplayError('New booking cannot be saved.', `${e.response.data.errorCode} / ${e.response.data.errorMessage}`)
            })
        } else {
          this.DisplayError('New booking cannot be saved.', 'Please check data requirements.')
        }
      })
    },
    onChangeSetBookingNumber() {
      const x = this.BKDetail.CustomerId.code
      const a = [{ year: '2-digit' }, { month: '2-digit' }, { day: '2-digit' }, {
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
      }]
      const s = this.join(new Date(), a, '').replace(' PM', '')
      this.BKDetail.BookingNumber = x + s.replace(':', '').replace(':', '')
    },
    join(t, a, s) {
      function format(m) {
        const f = new Intl.DateTimeFormat('en-US', m)
        return f.format(t)
      }
      return a.map(format).join(s)
    },
  },
}
</script>
